module.exports = __webpack_public_path__ + "static/media/existing-no-data.915311a8.svg";